import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { RoleActionPermissionsFragmentDoc } from '../dialogs/NewRoleDialog.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRolesForSelectQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRolesForSelectQuery = { __typename?: 'Query', Me?: { __typename?: 'Me', user: { __typename?: 'Employee', id: number, userType: Types.UserType, roles: Array<{ __typename?: 'Role', id: number, roleLevelV2?: number | null }> } } | null, Roles: { __typename?: 'Roles', objects: Array<{ __typename?: 'Role', id: number, name: string, roleLevelV2?: number | null, userCount: number, roleGroupMemberships: Array<{ __typename?: 'RoleGroupMembership', id: string, roleGroup: { __typename?: 'RoleGroup', id: string, name: string } }>, roleActionPermissions?: { __typename?: 'RoleActionPermissions', id: string, roleUserType: Types.UserType, requireClockInConfirmation: boolean, actionPermissions: { __typename?: 'ActionPermissionSet', id: string, changeOrgSettings?: boolean | null, manageOrgIntegrations?: boolean | null, manageBilling?: boolean | null, inviteOthers?: boolean | null, createContent?: boolean | null, manageLibrary?: boolean | null, assignContent?: boolean | null, unassignContent?: boolean | null, updateAutomations?: boolean | null, verifySkills?: boolean | null, viewReporting?: boolean | null, sendMessages?: boolean | null, sendPosts?: boolean | null, editTrainees?: boolean | null, deactivateTrainees?: boolean | null, managePremiumContent?: boolean | null, promoteTrainees?: boolean | null, markAsComplete?: boolean | null, viewAllSubmittedTaskLists?: boolean | null, createChat?: boolean | null } } | null, directReports: Array<{ __typename?: 'Role', id: number, name: string }> }> } };

export type RoleThinFragment = { __typename?: 'Role', id: number, name: string, roleLevelV2?: number | null, userCount: number, roleGroupMemberships: Array<{ __typename?: 'RoleGroupMembership', id: string, roleGroup: { __typename?: 'RoleGroup', id: string, name: string } }>, roleActionPermissions?: { __typename?: 'RoleActionPermissions', id: string, roleUserType: Types.UserType, requireClockInConfirmation: boolean, actionPermissions: { __typename?: 'ActionPermissionSet', id: string, changeOrgSettings?: boolean | null, manageOrgIntegrations?: boolean | null, manageBilling?: boolean | null, inviteOthers?: boolean | null, createContent?: boolean | null, manageLibrary?: boolean | null, assignContent?: boolean | null, unassignContent?: boolean | null, updateAutomations?: boolean | null, verifySkills?: boolean | null, viewReporting?: boolean | null, sendMessages?: boolean | null, sendPosts?: boolean | null, editTrainees?: boolean | null, deactivateTrainees?: boolean | null, managePremiumContent?: boolean | null, promoteTrainees?: boolean | null, markAsComplete?: boolean | null, viewAllSubmittedTaskLists?: boolean | null, createChat?: boolean | null } } | null, directReports: Array<{ __typename?: 'Role', id: number, name: string }> };

export const RoleThinFragmentDoc = gql`
    fragment RoleThin on Role {
  id
  name
  roleLevelV2
  userCount
  roleGroupMemberships {
    id
    roleGroup {
      id
      name
    }
  }
  roleActionPermissions {
    ...RoleActionPermissions
  }
  directReports {
    id
    name
  }
}
    ${RoleActionPermissionsFragmentDoc}`;
export const GetRolesForSelectDocument = gql`
    query GetRolesForSelect {
  Me {
    user {
      id
      userType
      roles {
        id
        roleLevelV2
      }
    }
  }
  Roles {
    objects {
      ...RoleThin
    }
  }
}
    ${RoleThinFragmentDoc}`;

/**
 * __useGetRolesForSelectQuery__
 *
 * To run a query within a React component, call `useGetRolesForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesForSelectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesForSelectQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesForSelectQuery, GetRolesForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesForSelectQuery, GetRolesForSelectQueryVariables>(GetRolesForSelectDocument, options);
      }
export function useGetRolesForSelectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesForSelectQuery, GetRolesForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesForSelectQuery, GetRolesForSelectQueryVariables>(GetRolesForSelectDocument, options);
        }
export type GetRolesForSelectQueryHookResult = ReturnType<typeof useGetRolesForSelectQuery>;
export type GetRolesForSelectLazyQueryHookResult = ReturnType<typeof useGetRolesForSelectLazyQuery>;
export type GetRolesForSelectQueryResult = Apollo.QueryResult<GetRolesForSelectQuery, GetRolesForSelectQueryVariables>;